import React from "react";
import ListingLoader from "../../component/LoaderTemplate";
import NoDataFound from "../../component/NoDataFound";
import { STATUS } from "../../constant";
import { isValidArray } from "../../helper";
import { SelectIssueTemplate } from "../../component/LoadersTemplate";
import SelectIssueSingle from "./SelectIssueSingle";
import LoadListOnScroll from "../../component/loadListOnScroll";

export default ({
  issues,
  isLoading,
  selectionHandler,
  IssueSelected,
  selectAll
}) => {
  const NoDataFoundIcon =
    "https://pmiic-local-files.s3.ap-south-1.amazonaws.com/no_data_found.png";
  return (
    <div>
      {isLoading === STATUS.LOADING ? (
        <ListingLoader
          times={10}
          height={100}
          children={<SelectIssueTemplate />}
        />
      ) : isValidArray(issues) ? (
        (issues || []).map((issue, index) => (
          <SelectIssueSingle
            issue={issue}
            idx={index}
            key={index}
            selectionHandler={selectionHandler}
            selectAll={selectAll}
            IssueSelected={IssueSelected}
          />
        ))
      ) : (
        // <NoDataFound />
        <div className="no-data-wrapper">
          <div className="img-container">
            <img src={NoDataFoundIcon} alt="No Data" />
            <h3 className={`no-data-found`}>
              NO ISSUES FOUND / ISSUES FROM SELECTED PROJECTS ALREADY ADDED IN
              AGENDA
            </h3>
          </div>
        </div>
      )}
    </div>
  );
};
